import NameSelector from "./NameSelector";


const Model = ({selectedModel, selectModel}) => {

    const handleModelChange = (model) => () => {
        selectModel(model);
    }

    return <div>
        <h2 className='section-title !mb-3'>Model</h2>
    <div className='flex gap-4'>
        <NameSelector name='90' onClick={handleModelChange(90)} selected={selectedModel === 90} />
        <NameSelector name='110' onClick={handleModelChange(110)} selected={selectedModel === 110} />
    </div>
  </div>;
}

export default Model;